(function () {
  var dataEl = document.getElementById('fqc-data');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);

  /* Color presets — matched to product variants by name in the variant title */
  var PRESETS = [
    { id: 'green',  name: 'Green',  born: 'Born Jan – Mar', hex: '#3E7A5E', tint: '#DCE8E0', ink: '#2E5E48' },
    { id: 'red',    name: 'Red',    born: 'Born Apr – Jun', hex: '#A5352E', tint: '#EFD3CF', ink: '#86271F' },
    { id: 'yellow', name: 'Yellow', born: 'Born Jul – Sep', hex: '#D1A23A', tint: '#F3E6C4', ink: '#7E5E17' },
    { id: 'white',  name: 'White',  born: 'Born Oct – Dec', hex: '#EEEAE2', tint: '#F1EEE7', ink: '#6E675A' }
  ];
  var MAX_QTY = 20;

  var colors = [];
  PRESETS.forEach(function (p) {
    var v = D.variants.find(function (x) { return x.available && x.title.toLowerCase().indexOf(p.id) !== -1; });
    if (v) colors.push(Object.assign({}, p, { variant: v }));
  });
  if (!colors.length) {
    // Fallback: product variants don't use the preset color names
    colors = D.variants.filter(function (v) { return v.available; }).map(function (v, i) {
      var p = PRESETS[i % PRESETS.length];
      return Object.assign({}, p, { id: 'v' + v.id, name: v.title, born: '', variant: v });
    });
  }
  if (!colors.length) return;

  var state = { color: colors[0].id, qty: 1, extras: {}, bump: false, busy: false };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /*
    Prices follow the shop's money format for the visitor's currency, like the
    landing prices printed by Liquid. The format is read from a sample amount
    (1234567.89) that Liquid formatted; whole amounts drop ".00" the same way
    money_without_trailing_zeros does.
  */
  var money = (function () {
    var m = /^(.*?)(\d[\d.,'\s\u00a0]*\d)(.*)$/.exec(D.moneySample || '');
    if (!m) {
      var fmt;
      try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: D.currency || 'USD' }); } catch (e) { fmt = null; }
      return function (cents) { var n = cents / 100; return fmt ? fmt.format(n) : '$' + n.toFixed(2); };
    }
    var prefix = m[1], digits = m[2], suffix = m[3];
    var dec = /^(.*\d)([.,])(\d{2})$/.exec(digits);
    var decimalSep = dec && dec[3] === '89' ? dec[2] : '';
    var groupSep = ((decimalSep ? dec[1] : digits).match(/\D/) || [''])[0];
    return function (cents) {
      var c = Math.round(cents);
      var whole = decimalSep ? Math.floor(c / 100) : Math.round(c / 100);
      var frac = decimalSep ? c % 100 : 0;
      var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
      if (frac) out += decimalSep + (frac < 10 ? '0' : '') + frac;
      return prefix + out + suffix;
    };
  })();
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
  var byId = function (id) { return colors.find(function (c) { return c.id === id; }) || colors[0]; };
  var reg = function (c) { return Math.max(c.variant.compare, c.variant.price); };
  var clamp = function (n) { return Math.max(1, Math.min(MAX_QTY, n)); };
  var rateFor = function (n) { return n >= 3 ? D.tier3 / 100 : n === 2 ? D.tier2 / 100 : 0; };
  var codeFor = function (n) { return n >= 3 ? D.code3 : n === 2 ? D.code2 : ''; };

  function pendant(c, w, h, sw) {
    if (c.variant.img) return '<img src="' + esc(c.variant.img) + '" alt="' + esc(c.name) + '" loading="lazy">';
    return '<svg width="' + w + '" height="' + h + '" viewBox="0 0 72 96" fill="none" stroke="' + c.ink + '" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M36 24C12 38 8 70 36 92C64 70 60 38 36 24Z"/></svg>';
  }

  function lines() {
    var ls = [{ c: byId(state.color), qty: state.qty }];
    colors.forEach(function (c) {
      if (c.id !== state.color && (state.extras[c.id] || 0) > 0) ls.push({ c: c, qty: state.extras[c.id] });
    });
    return ls;
  }
  function totals() {
    var ls = lines();
    var units = ls.reduce(function (a, l) { return a + l.qty; }, 0);
    var bump = state.bump && D.bump;
    var necklaces = ls.reduce(function (a, l) { return a + l.c.variant.price * l.qty; }, 0);
    var base = necklaces + (bump ? D.bump.price : 0);
    var regular = ls.reduce(function (a, l) { return a + reg(l.c) * l.qty; }, 0) + (bump ? D.bump.price : 0);
    var rate = rateFor(units);
    // The discount code only covers the necklaces, so the bump stays at full price
    var disc = Math.round(necklaces * rate);
    return { ls: ls, units: units, base: base, rate: rate, disc: disc, total: base - disc, regular: regular };
  }
  function nudgeText(n) {
    var cur = Math.round(rateFor(n) * 100);
    var next = [[2, D.tier2], [3, D.tier3]].filter(function (x) { return x[0] > n && x[1] > cur; })[0];
    if (next) return (cur ? cur + '% off applied · ' : '') + 'Add ' + (next[0] - n) + ' more necklace' + (next[0] - n > 1 ? 's' : '') + ' to get ' + next[1] + '% off your order';
    return cur ? cur + '% off your whole order applied' : '';
  }

  function render() {
    var cur = byId(state.color);
    var t = totals();

    // price header
    $('#unitPrice').textContent = money(cur.variant.price);
    var hasReg = reg(cur) > cur.variant.price;
    $('#unitReg').textContent = hasReg ? money(reg(cur)) : '';
    $('#unitBadge').hidden = !hasReg;
    $('#unitBadge').textContent = hasReg ? 'Save ' + Math.round((1 - cur.variant.price / reg(cur)) * 100) + '%' : '';

    // gallery
    var hero = $('#heroImg');
    hero.style.background = cur.tint;
    hero.innerHTML = cur.variant.img ? pendant(cur) :
      '<svg width="120" height="160" viewBox="0 0 72 96" fill="none" stroke="' + cur.ink + '" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M36 2v14"/><circle cx="36" cy="20" r="4"/><path d="M36 24C12 38 8 70 36 92C64 70 60 38 36 24Z"/><path d="M25 58l6-11 5 8 5-8 6 11"/></svg>';
    $('#thumbs').innerHTML = colors.map(function (c) {
      return '<button type="button" class="thumb ' + (c.id === state.color ? 'on' : '') + '" style="background:' + c.tint + '" data-color="' + c.id + '" aria-label="Show ' + esc(c.name) + '">' + pendant(c, 34, 46, 3) + '</button>';
    }).join('');

    // color
    $('#colorLabel').innerHTML = 'Color: ' + esc(cur.name) + (cur.born ? ' <span class="sub">· ' + cur.born + '</span>' : '');
    $('#swatches').innerHTML = colors.map(function (c) {
      return '<button type="button" class="swatch ' + (c.id === state.color ? 'on' : '') + '" data-color="' + c.id + '" aria-pressed="' + (c.id === state.color) + '"><span class="c" style="background:' + c.hex + '"></span><span><b>' + esc(c.name) + '</b>' + (c.born ? '<small>' + c.born + '</small>' : '') + '</span></button>';
    }).join('');

    // qty
    if (document.activeElement !== $('#qty')) $('#qty').value = state.qty;
    $('#selMain').textContent = money(cur.variant.price * state.qty);
    $('#selMainReg').textContent = hasReg ? money(reg(cur) * state.qty) : '';

    // tiers (block is not rendered when no discount is configured)
    if ($('#tierList')) {
      var tiers = [[1, '1 necklace', 'Regular'], [2, '2 necklaces', D.tier2 ? D.tier2 + '% off' : 'Regular'], [3, '3 or more', D.tier3 + '% off']];
      $('#tierList').innerHTML = tiers.map(function (x) {
        return '<li class="' + (t.units >= x[0] ? 'on' : '') + '"><span class="d"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg></span><small>' + x[1] + '</small><strong>' + x[2] + '</strong></li>';
      }).join('');
      $('#trackFill').style.width = (t.units >= 3 ? 100 : t.units === 2 ? 50 : 0) + '%';
      $('#nudge').textContent = nudgeText(t.units);
    }

    // FBT
    var others = colors.filter(function (c) { return c.id !== state.color; });
    $('#fbt').hidden = !others.length;
    var allOn = others.every(function (c) { return (state.extras[c.id] || 0) > 0; });
    $('#toggleAll').textContent = allOn ? 'Clear all' : 'Select all';
    $('#fbtList').innerHTML = others.map(function (c) {
      var on = (state.extras[c.id] || 0) > 0;
      var q = on ? state.extras[c.id] : 1;
      return '<div class="fbt-row ' + (on ? 'on' : '') + '">' +
        '<input id="fbt-' + c.id + '" type="checkbox" ' + (on ? 'checked' : '') + ' data-fbt="' + c.id + '">' +
        '<label for="fbt-' + c.id + '" class="mini" style="background:' + c.tint + '">' + pendant(c, 18, 26, 3) + '</label>' +
        '<div class="fbt-mid"><label for="fbt-' + c.id + '" class="fbt-name"><b>Fox Queen · ' + esc(c.name) + '</b>' + (c.born ? '<small>' + c.born + '</small>' : '') + '</label>' +
        (on ? '<span class="stepper sm"><button type="button" data-fbt-dec="' + c.id + '" aria-label="Decrease ' + esc(c.name) + '">−</button><span>' + q + '</span><button type="button" data-fbt-inc="' + c.id + '" aria-label="Increase ' + esc(c.name) + '">+</button></span>' : '') +
        '</div><span class="pcol"><b>' + money(c.variant.price * q) + '</b>' + (reg(c) > c.variant.price ? '<s>' + money(reg(c) * q) + '</s>' : '') + '</span></div>';
    }).join('');

    var h = '<div class="r"><span class="k">Subtotal · ' + t.units + ' necklace(s)' + (state.bump && D.bump ? ' + bracelet' : '') + '</span><span>' + money(t.base) + '</span></div>';
    if (t.rate > 0) h += '<div class="r disc"><span>Multi-buy discount (' + Math.round(t.rate * 100) + '% off)</span><span>−' + money(t.disc) + '</span></div>';
    else if (nudgeText(t.units)) h += '<div class="tip warn">' + esc(nudgeText(t.units)) + '</div>';
    h += '<div class="r"><span class="k">Shipping</span><span style="font-weight:700;color:var(--accent)">' + (D.shipCode ? 'FREE with code ' + esc(D.shipCode) : 'FREE') + '</span></div>';
    h += '<div class="r total"><span class="k">Total</span><span class="v">' + (t.regular > t.total ? '<s>' + money(t.regular) + '</s>' : '') + '<b>' + money(t.total) + '</b></span></div>';
    if (D.taxNote) h += '<div class="tip">' + esc(D.taxNote) + '</div>';
    $('#selRows').innerHTML = h;
    $$('[data-sel-total]').forEach(function (el) { el.textContent = money(t.total); });

    $('#buyBtn').disabled = state.busy;
  }

  function set(patch) { Object.assign(state, patch); render(); }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        return j;
      });
    });
  }

  function checkout() {
    if (state.busy) return;
    var t = totals();
    var items = t.ls.map(function (l) { return { id: l.c.variant.id, quantity: l.qty }; });
    if (state.bump && D.bump) items.push({ id: D.bump.id, quantity: 1 });
    var err = $('#buyErr');
    err.hidden = true;
    set({ busy: true });
    $('#buyLabel').textContent = 'Preparing secure checkout…';

    (D.clearCart ? post('/cart/clear.js') : Promise.resolve())
      .then(function () { return post('/cart/add.js', { items: items }); })
      .then(function () {
        // Shopify accepts several combinable codes, comma separated
        var codes = [codeFor(t.units), D.shipCode].filter(Boolean).join(',');
        window.location.href = '/checkout' + (codes ? '?discount=' + encodeURIComponent(codes) : '');
      })
      .catch(function (e) {
        err.textContent = e.message + '. Please try again.';
        err.hidden = false;
        $('#buyLabel').innerHTML = 'Checkout securely · <span data-sel-total></span>';
        set({ busy: false });
      });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('button, [data-color]');
    if (!el) return;
    if (el.dataset.color) {
      var ex = Object.assign({}, state.extras); delete ex[el.dataset.color];
      return set({ color: el.dataset.color, extras: ex });
    }
    if (el.id === 'qtyDec') return set({ qty: clamp(state.qty - 1) });
    if (el.id === 'qtyInc') return set({ qty: clamp(state.qty + 1) });
    if (el.dataset.fbtInc) { var a = Object.assign({}, state.extras); a[el.dataset.fbtInc] = clamp((a[el.dataset.fbtInc] || 1) + 1); return set({ extras: a }); }
    if (el.dataset.fbtDec) { var b = Object.assign({}, state.extras); b[el.dataset.fbtDec] = clamp((b[el.dataset.fbtDec] || 1) - 1); return set({ extras: b }); }
    if (el.id === 'toggleAll') {
      var others = colors.filter(function (c) { return c.id !== state.color; });
      var allOn = others.every(function (c) { return (state.extras[c.id] || 0) > 0; });
      var n = {}; if (!allOn) others.forEach(function (c) { n[c.id] = state.extras[c.id] || 1; });
      return set({ extras: n });
    }
    if (el.id === 'buyBtn') return checkout();
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset.fbt) { var ex = Object.assign({}, state.extras); ex[t.dataset.fbt] = t.checked ? 1 : 0; set({ extras: ex }); }
    if (t.id === 'bump') set({ bump: t.checked });
    if (t.id === 'qty') { var v = parseInt(t.value, 10); set({ qty: isNaN(v) ? 1 : clamp(v) }); t.value = state.qty; }
  });
  $('#qty').addEventListener('input', function (e) {
    var v = parseInt(e.target.value, 10);
    if (!isNaN(v)) set({ qty: clamp(v) });
  });
  // Reset button state when returning via browser back (bfcache)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && state.busy) { $('#buyLabel').innerHTML = 'Checkout securely · <span data-sel-total></span>'; set({ busy: false }); }
  });

  // Embedded in a Fox Queen landing: the Webcake runtime opens "#..." links in a new tab, so catch
  // ORDER NOW clicks before it does (capture phase) and scroll to the order block instead.
  var embed = document.querySelector('.fqe#fq-order');
  if (embed) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#fq-order"]');
      if (!a) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var top = embed.getBoundingClientRect().top + window.pageYOffset - 70; // clear the sticky stock bar
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, true);
  }

  // The bump price is printed by Liquid, so restate it with the same formatter as every other price
  if (D.bump) {
    var bp = $('[data-bump-price]');
    if (bp) bp.textContent = money(D.bump.price);
    var bc = $('[data-bump-compare]');
    if (bc && D.bump.compare > D.bump.price) bc.textContent = money(D.bump.compare);
  }

  render();
})();
